import { compose, take, map, any, mergeDeepLeft, update, prepend } from 'ramda';
import { getAttributes } from '../../../../Model/avenyModelUtils';
import {
  IClientBusinessModel,
  IClientAttributeModel,
} from '../../../../Types/ClientModelTypes';
import { IColumnDef } from '../../../../Types/ColumnDefType';
import { findCollectionStatic } from '../../../../Model/avenyStaticModelUtils';
import { isEmpty } from 'ramda';
import { findBusinessconfig, IBusinessConfig } from '../Const/BusinessConfigs';
import { rutiner } from '../Const/Rutiner';
import { Breakpoint } from '../../../../BaseComponents/ThemeProvider/AvenyTheme';
import { breakpointIsLargerOrEqual } from '../../../../Components/BreakpointContext/BreakpointContextUtils';

const firstFields = (collection: IClientBusinessModel): IColumnDef[] =>
  compose(
    map(
      (attr: IClientAttributeModel): IColumnDef => ({
        attributeDef: attr.AttributeName,
        caption: attr.DisplayLabel,
      })
    ),
    take(5)
  )(getAttributes(collection));

const insertHeaderColumns = (
  columnsArg: readonly IColumnDef[],
  columnsFromConfig: IColumnDef[]
): readonly IColumnDef[] => {
  let columns = columnsArg;

  const headerColumns = columnsFromConfig.filter(column => column.header);

  headerColumns.forEach(headerColumn => {
    const index = columns.findIndex(
      column => column.attributeDef === headerColumn.attributeDef
    );
    if (index !== -1) {
      columns = update(index, { ...columns[index], header: true }, columns);
    } else {
      columns = prepend({ ...headerColumn, disableSave: true }, columns);
    }
  });

  return columns;
};
export const defaultColumns = (
  collectionFieldName: string,
  rutinKod?: string | null,
  listLayoutColumnDefs?: readonly IColumnDef[],
  currentWidth?: Breakpoint
): readonly IColumnDef[] => {
  const routineConfig = rutinKod
    ? rutiner[rutinKod]?.config?.[collectionFieldName]
    : undefined;
  const businessConfig = findBusinessconfig(collectionFieldName);

  const config =
    routineConfig && businessConfig
      ? (mergeDeepLeft(routineConfig, businessConfig) as IBusinessConfig)
      : businessConfig;
  if (listLayoutColumnDefs) {
    const columns = listLayoutColumnDefs;

    if (config) {
      return insertHeaderColumns(
        columns,
        config.defaultColumns.filter(col =>
          breakpointIsLargerOrEqual(col.minSize ?? 'xs', currentWidth ?? 'xl')
        )
      );
    }
    return columns;
  }
  if (config) {
    return config.defaultColumns.filter(col =>
      breakpointIsLargerOrEqual(col.minSize ?? 'xs', currentWidth ?? 'xl')
    );
  }
  const collection = findCollectionStatic(collectionFieldName);
  if (collection) {
    return firstFields(collection);
  }
  return [];
};

export const headerColumns = (
  collectionFieldName: string,
  rutinKod?: string
): IColumnDef[] => {
  const defCols = defaultColumns(collectionFieldName, rutinKod);
  const headerCols = defCols.filter(col => col.header);
  return isEmpty(headerCols) ? take(1, defCols) : headerCols;
};

export const isHeader = (
  collectionFieldName: string,
  attributeName: string,
  rutinKod?: string
): boolean => {
  return any<IColumnDef>(
    col => !!col.header && col.attributeDef === attributeName,
    defaultColumns(collectionFieldName, rutinKod)
  );
};

export default defaultColumns;
